import React from "react";
import _ from "lodash";
import { trans } from "@cortexglobal/rla-intl";
import {
    Row,
    Column,
    Button,
    IconTextButton
} from "@cortexglobal/rla-components";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
    faFolder,
    faTimes,
    faLevelUpAlt
} from "@fortawesome/free-solid-svg-icons";

class SubFolders extends React.Component {
    openFolder = item => {
        this.props.openFolder(item);
    };

    closeFolders = () => {
        this.props.closeFolders();
    };

    render() {
        const { folders, parents } = this.props;

        return (
            <Row>
                {parents && parents.length > 0 && (
                    <IconTextButton
                        style={{ float: "left" }}
                        showCircle={false}
                        expanded={false}
                        icon={faLevelUpAlt}
                        onClick={this.openFolder.bind(this, parents[0])}
                    >
                        ...
                    </IconTextButton>
                )}
                {folders &&
                    Object.keys(folders).map(index => {
                        const folder = folders[index];

                        return (
                            <IconTextButton
                                style={{ float: "left" }}
                                showCircle={false}
                                expanded={false}
                                icon={faFolder}
                                onClick={this.openFolder.bind(this, folder)}
                            >
                                {folder.name}
                            </IconTextButton>
                        );
                    })}
                <IconTextButton
                    style={{ float: "right" }}
                    showCircle={false}
                    expanded={false}
                    icon={faTimes}
                    onClick={this.closeFolders}
                >
                    {trans("close")}
                </IconTextButton>
            </Row>
        );
    }
}

export default SubFolders;
